import { useAppDispatch, useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import { useCallback, useEffect, useState } from 'react'
import { processingJobFilter } from '../../state/jobsProcessingSagas'
import {
  clearProcessingJobsRequest,
  getProcessingJobsRequest,
  areProccesingJobsInProgress,
  setCurrentProcessingJob
} from '../../state/jobsProcessingSlice'
import { ProcessingJob, JobStatusType } from '../../types'
import { getLastTwentyFourHours } from 'features/jobs/utils'

export const CARTO_IGNORED_PROCESSING_JOBS = 'CARTO_IGNORED_PROCESSING_JOBS'

function useProcessingJobs() {
  const dispatch = useAppDispatch()
  const userMe = useAppSelector((state) => state.users.me)
  const processingJobsStatus = useAppSelector((state) => state.jobs.processingJobsStatus)
  const processingJobs = useAppSelector((state) => state.jobs.processingJobs)
  const areAnyProcessingJobsRunning = useAppSelector(areProccesingJobsInProgress)
  const currentProcessingJob = useAppSelector((state) => state.jobs.currentProcessingJob)

  const [filteredProcessingJobs, setFilteredProcessingJobs] = useState<ProcessingJob[]>([])
  const [clearableJobs, setClearableJobs] = useState<ProcessingJob[]>([])

  const clearProcessingJobs = useCallback(() => {
    const filtered = processingJobs.filter(processingJobFilter)
    const clearable = filtered.filter(
      (job) => job.status && [JobStatusType.Failure, JobStatusType.Success].includes(job.status.status)
    )
    setFilteredProcessingJobs(filtered)
    setClearableJobs(clearable)
  }, [processingJobs])

  useEffect(() => {
    if (processingJobsStatus === RequestStatus.Idle) {
      dispatch(
        getProcessingJobsRequest({
          owner: userMe?.user_id,
          createdSince: getLastTwentyFourHours()
        })
      )
    }
  }, [processingJobsStatus, userMe, dispatch])

  useEffect(() => {
    clearProcessingJobs()
  }, [clearProcessingJobs, processingJobs, dispatch])

  useEffect(() => {
    return () => {
      dispatch(setCurrentProcessingJob())
    }
  }, [dispatch])

  const clearJobs = () => {
    dispatch(clearProcessingJobsRequest(clearableJobs))
  }

  return {
    processingJobs,
    areAnyProcessingJobsRunning,
    processingJobsNotCleared: filteredProcessingJobs,
    clearJobs,
    clearableJobs,
    currentProcessingJob
  }
}

export default useProcessingJobs
